import Model from 'flarum/common/Model';

/** The failed check that opened the incident (FailureEvidence.php). */

export default class Incident extends Model {
  monitorId = (() => Model.attribute('monitorId'))();
  monitorName = (() => Model.attribute('monitorName'))();
  url = (() => Model.attribute('url'))();
  cause = (() => Model.attribute('cause'))();
  causeHeadline = (() => Model.attribute('causeHeadline'))();
  causeSentence = (() => Model.attribute('causeSentence'))();
  severity = (() => Model.attribute('severity'))();
  ongoing = (() => Model.attribute('ongoing'))();
  durationSeconds = (() => Model.attribute('durationSeconds'))();
  timeline = (() => Model.attribute('timeline'))();
  hasEvidence = (() => Model.attribute('hasEvidence'))();
  /** Only on a single-incident read; undefined until that has loaded. */
  evidence = (() => Model.attribute('evidence'))();
  /** A free owner's incident has a snapshot (and, if lockedCause, a diagnosis) that Pro would show. Never the content. */
  /** 2 when this server's own check agreed with the edge's that the site was down; null otherwise. */
  confirmedNetworks = (() => Model.attribute('confirmedNetworks'))();
  lockedEvidence = (() => Model.attribute('lockedEvidence'))();
  lockedCause = (() => Model.attribute('lockedCause'))();
  hasScreenshot = (() => Model.attribute('hasScreenshot'))();
  screenshotUrl = (() => Model.attribute('screenshotUrl'))();
  startedAt = (() => Model.attribute('startedAt', Model.transformDate))();
  endedAt = (() => Model.attribute('endedAt', Model.transformDate))();
}
flarum.reg.add('linkrobins-lr-monitoring', 'models/Incident', Incident);